import React, {useState} from 'react'
import { AiOutlineTag } from "@react-icons/all-files/ai/AiOutlineTag";
import { FaRegHandshake } from "@react-icons/all-files/fa/FaRegHandshake";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { AiOutlineCompass } from "@react-icons/all-files/ai/AiOutlineCompass";
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";
import { AiOutlineCheck } from "@react-icons/all-files/ai/AiOutlineCheck";
import { AiOutlinePercentage } from "@react-icons/all-files/ai/AiOutlinePercentage";
import oneh from '../public/Pictures/model1_header.jpg'
import twoh from '../public/Pictures/model2_header.jpg'
import threeh from '../public/Pictures/model3_header.jpg'
import fourh from '../public/Pictures/model4_header.jpg'
import PicCont from './PicCont'
import Button from './Button'
const B2BIndex = ({one, two, three, four, choose, selected, setSelected, setModel}) => {
  console.log(setModel)

  return <section className='b2bIndex'>
 {!choose &&       <div className='upperBold'>Partnership Models</div>}
        <div className="row">
        {one && <div className={`indexCard ${selected?.one ? 'sel': ''}`}>
            <div className='top'>
                <div className='back'></div>
                <div className='text'>
                    <AiOutlineTag />
                    <strong>White Label Partnership</strong>
                </div>
                <PicCont background src={oneh}/>
            </div>
            <div className='bottom'>
                <p>We act as our partner’s internal AV division. Off branded billing with applied discounts issued to our partner for a full control price control.</p>
              {choose ?
                <Button className=' btn-3  highLight' onClick={() => setSelected({one: !selected?.one})} >{selected?.one? 'Unselect' : 'Select Model'}</Button>
              :
                <a href='#model1' onClick={()=> setModel('one')} className='button btn-3  highLight' >Learn More</a>
                }
            </div>

            </div>}
        {two && <div className={`indexCard ${selected?.two ? 'sel': ''}`}>
            <div className='top'>
                <div className='back'></div>
                <div className='text'>
                <FaRegHandshake />
                <strong>Audio Visual Partners</strong>
                </div>
                <PicCont background src={twoh} />
            </div>
            <div className='bottom'>
                <p>Data driven referral recognition and  automatic commission system through Partner Portal.</p>
                {choose ?
                <Button className=' btn-3  highLight' onClick={() => setSelected({two: !selected?.two, three: selected?.three})} >{selected?.two? 'Unselect' : 'Select Model'}</Button>
              :
                <a href='#model2' onClick={()=> setModel('two')}  className='button btn-3  highLight' >Learn More</a>}
            </div>

            </div>}
        {three && <div className={`indexCard ${selected?.three ? 'sel': ''}`}>
            <div className='top'>
                <div className='back'></div>
                <div className='text'>
                <AiOutlineCompass />
                <strong>AV Compass</strong>
                </div>
                <PicCont background src={threeh}/>
            </div>
            <div className='bottom'>
                <p>Top rated  full AV outsourcing thanks to operational excellence leveraged in our proprietary technology. White label quoting with discounts that allow higher markups.</p>
                {choose ?
                <Button className=' btn-3  highLight' onClick={() => setSelected({three: !selected?.three, two: selected?.two})} >{selected.three? 'Unselect' : 'Select Model'}</Button>
              :
                <a href='#model3' onClick={()=> setModel('three')}  className='button btn-3  highLight' >Learn More</a>}
            </div>

            </div>}
        {four && <div className={`indexCard ${selected?.four ? 'sel': ''}`}>
            <div className='top'>
                <div className='back'></div>
                <div className='text'>
                <AiOutlinePercentage />
                <strong>Referral Discount Program</strong>
                </div>
                <PicCont background src={fourh}/>
            </div>
            <div className='bottom'>
                <p>Automatic discount on AV simply for referring clients to us. Incentive to attract and tress-free referrals by relaying in #01 Rated AV service.</p>
                {choose ?
                <Button className=' btn-3  highLight' onClick={() => setSelected({four: !selected?.four})} >{selected?.four? 'Unselect' : 'Select Model'}</Button>
              :
                <a href='#model4' onClick={()=> setModel('four')}  className='button btn-3  highLight' >Learn More</a>}
            </div>

            </div>}
            </div>
            {choose && <div className='buttons'>
                <Button className='btn-5  highLight' onClick={choose}>Continue</Button>
                </div>}

  </section>
}

export default B2BIndex